/**
 * ADGMQ
 * imedia
 *
 * Register form
 */

import $ from 'jquery';
import validate from 'jquery-validation';

jQuery.validator.addMethod(
  'canadianPostalCode',
  function(postal, element) {
    return (
      this.optional(element) ||
      postal.match(/[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]/)
    );
  },
  'Please specify a valid postal code',
);

jQuery.validator.addMethod(
  'phoneUS',
  function(phone_number, element) {
    return (
      this.optional(element) ||
      (phone_number.length > 9 &&
        phone_number.match(/^[2-9]\d{2}\s+[2-9]\d{2}\-\d{4}/))
    );
  },
  'Please specify a valid phone number',
);

jQuery.validator.setDefaults({
  ignore: [],
});

(function($) {
  if ($('body').hasClass('page-template-template-register')) {
    const registerForm = $('#registration form[name="registration"]');

    var elem = window.location.hash.replace('#', '');

    if (elem) {
      $('body, html').animate(
        {
          scrollTop: $('#' + elem).offset().top,
        },
        200,
      );
    }

    if (registerForm) {
      render_recaptcha();

      setInterval(() => {
        render_recaptcha();
      }, 2 * 60 * 1000);

      registerForm.validate({
        invalidHandler: function(event, validator) {
          if (grecaptcha) {
            grecaptcha.reset();
          }
        },
        rules: {
          firstname: {
            required: true,
          },
          lastname: {
            required: true,
          },
          organization: {
            required: true,
          },
          address: {
            required: true,
          },
          city: {
            required: true,
          },
          postal_code: {
            required: true,
            canadianPostalCode: true,
          },
          email: {
            required: true,
            email: true,
          },
          email_secondary: {
            required: false,
            email: true,
          },
          phone: {
            required: true,
            phoneUS: true,
          },
          secondary_phone: {
            phoneUS: true,
          },
          cellphone: {
            phoneUS: true,
          },
          fax: {
            phoneUS: true,
          },
          picture: {
            required: true,
            // accept: 'image/jpeg, image/jpeg, image/png',
          },
          acceptance: {
            required: true,
          },
          'g-recaptcha-response': {
            required: true,
            minlength: '255',
          },
        },
        errorPlacement: function(error, element) {
          var fieldName = element.attr('name');

          if (fieldName == 'picture') {
            return error.appendTo(
              element
                .parent()
                .next()
                .next(),
            );
          } else if (fieldName == 'acceptance') {
            return error.appendTo(element.next());
          } else {
            return true;
          }
        },
        messages: {
          picture: {
            required: 'Vous devez joindre une photographie de profil',
          },
          acceptance: {
            required: "Cette condition n'est pas optionnelle",
          },
          'g-recaptcha-response': {
            required: 'Impossible de soumettre le formulaire',
          },
        },
        submitHandler: function(form) {
          form.submit();
        },
      });
    }
  }

  /**
   * Execute reCaptcha
   */
  function render_recaptcha() {
    const gRecaptchaResponse = $('input#g-recaptcha-response');

    if (grecaptcha && gRecaptchaResponse.length) {
      if (wpcf7_recaptcha !== 'undefined' && wpcf7_recaptcha.sitekey) {
        grecaptcha.ready(function() {
          grecaptcha
            .execute(wpcf7_recaptcha.sitekey, {
              action: 'validate_captcha',
            })
            .then(function(token) {
              gRecaptchaResponse.val(token);
            });
        });
      }
    }
  }
})(jQuery);
